import React, { useState, useEffect } from "react";
import { ReactComponent as SearchIcon } from "../../../ui/markSearchIcons/search_icon.svg";
import styles from "./articleFilterOptons.module.css";
import { Select } from "../../../ui/select/Select";
import { Button } from "../../../ui/button/Button";
import { useArticleFilter } from "../../../../hooks/useArticleFilter";
import { useSearchParams } from "react-router";
import { useDebounceValue } from "usehooks-ts";

const carPartsCategories = [
    { id: 0, value: null, text: "Все" },
    { id: 1, value: 1, text: "Щетки" },
    { id: 2, value: 2, text: "Фильтры" },
    { id: 3, value: 3, text: "Тормозные колодки" },
];

export function ArticleFilterOptons({ closeModal, isOpen }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const { toggleEnabled } = useArticleFilter();

    const [inputValue, setInputValue] = useState(
        searchParams.get("part_number") || ""
    );

    const [debouncedValue] = useDebounceValue(inputValue, 1000);

    useEffect(() => {
        if (isOpen) return;

        const newSearchParams = new URLSearchParams(searchParams);

        if (debouncedValue) {
            newSearchParams.set("part_number", debouncedValue);
        } else {
            newSearchParams.delete("part_number");
        }

        setSearchParams(newSearchParams, {
            replace: true,
            preventScrollReset: true,
        });
    }, [debouncedValue, isOpen]);

    useEffect(() => {
        if (isOpen) return;

        const partFromParams = searchParams.get("part_number") || "";
        setInputValue(partFromParams);
    }, [searchParams, isOpen]);

    const handleSearchChangePart = (e) => {
        setInputValue(e.target.value);
    };

    const handleCategoryChange = (value) => {
        const newSearchParams = new URLSearchParams(searchParams);

        if (value) {
            newSearchParams.set("category_id", value);
        } else {
            newSearchParams.delete("category_id");
        }

        setSearchParams(newSearchParams, {
            replace: true,
            preventScrollReset: true,
        });
    };
    function handleOemSearch() {
        const newSearchParams = new URLSearchParams(searchParams);

        if (inputValue) {
            newSearchParams.set("part_number", inputValue);
        } else {
            newSearchParams.delete("part_number");
        }

        setSearchParams(newSearchParams, {
            replace: true,
            preventScrollReset: true,
        });

        toggleEnabled(inputValue);
        closeModal?.(false);
    }

    return (
        <div className={styles.article_filter}>
            <div className={styles.input_wrapper}>
                <strong>Фильтр</strong>

                <div className={styles.input_holder}>
                    <input
                        type="text"
                        placeholder="Введите номер"
                        className={styles.input}
                        value={inputValue}
                        onChange={handleSearchChangePart}
                    />
                    <SearchIcon className={styles.search_icon} />
                </div>

                <Select
                    placeholder="Товарная группа"
                    items={carPartsCategories}
                    value={searchParams.get("category_id") ?? ""}
                    setValue={handleCategoryChange}
                />
            </div>
            <div className={styles.button}>
                <Button
                    disabled={!inputValue}
                    onClick={handleOemSearch}
                    variant="yellow"
                    width="w-455"
                >
                    Поиск
                </Button>
            </div>
        </div>
    );
}
